/** @format */
import { Injectable } from '@angular/core';
import { TranslationMarkupRendererFactory } from 'ngx-transloco-markup';
import { HtmlElementTranspiler } from '../common/html-element-transpiler';

export const UL_START = new (class UlStart {})();
export const UL_END = new (class UlEnd {})();

@Injectable()
export class UlTranspiler extends HtmlElementTranspiler {
    constructor(private readonly rendererFactory: TranslationMarkupRendererFactory) {
        super({
            rendererFactory,
            start: {
                search: '<ul>',
                token: UL_START,
            },
            end: {
                search: '</ul>',
                token: UL_END,
            },
            elementTag: 'ul',
        });
    }
}
